import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import OrderPunch from "./pages/OrderPunch";
import KDS from "./pages/KDS";
import Dispatch from "./pages/Dispatch";
import CashierPending from "./pages/CashierPending";
import DayEnd from "./pages/DayEnd";
import NavBar from "./components/NavBar";
import SalesReport from "./pages/SalesReport";

function App() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const isLoggedIn = !!token;

  if (!isLoggedIn) {
    return <Login onLogin={() => window.location.reload()} />;
  }

  // 🔐 Role-based default landing page
  const getDefaultRoute = () => {
    if (role === "CASHIER") return "/punch";
    if (role === "CHEF") return "/kds";
    if (role === "DISPATCH") return "/dispatch";
    if (role === "MANAGER") return "/kds";
    return "/punch";
  };

  return (
    <>
      <NavBar />

      <Routes>
        {/* Default redirect */}
        <Route path="/" element={<Navigate to={getDefaultRoute()} />} />

        {/* CASHIER */}
        <Route
          path="/punch"
          element={
            role === "CASHIER" ? (
              <OrderPunch />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />

        <Route
          path="/sales-report"
          element={
            role === "MANAGER" ? (
              <SalesReport />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />

        <Route
          path="/cashier"
          element={
            role === "CASHIER" ? (
              <CashierPending />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />

        {/* CHEF */}
        <Route
          path="/kds"
          element={
            role === "CHEF" || role === "MANAGER" ? (
              <KDS />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />

        {/* DISPATCH */}
        <Route
          path="/dispatch"
          element={
            role === "DISPATCH" || role === "MANAGER" ? (
              <Dispatch />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />

        {/* DAY END – Manager Only */}
        <Route
          path="/day-end"
          element={
            role === "MANAGER" ? (
              <DayEnd />
            ) : (
              <Navigate to={getDefaultRoute()} />
            )
          }
        />
      </Routes>
    </>
  );
}

export default App;